export const ANNUAL_INTEREST = {
  LOAN: 2.95/100,
  MIN: 2.95/100,
  MAX: 6.78/100
}
export const CREDIT_CARD = {
  MIN_PAY_RATE: 5 / 100,
  MIN_PAY_AMOUNT: 50,
  INTEREST_RATE: 30/100,
  COUNTER_TENOR: 72
}
export const TENORS = [6, 12, 18, 24, 36, 48, 60]
export const LOAN_AMOUNT = {
  MAX: 2000000,
  MIN: 5000,
  DEFAULT: 200000
}
export const LOAN2_AMOUNT = {
  MAX: 1000000,
  MIN: 2000,
  DEFAULT: 200000
}
